(function () {
  var DRAG_THRESHOLD = 8;
  var ARROW_THRESHOLD = 20;

  var styleId = 'drag-scroll-styles';
  if (!document.getElementById(styleId)) {
    var style = document.createElement('style');
    style.id = styleId;
    style.textContent =
      '.drag-scroll-nav {' +
        'position: relative;' +
      '}' +
      '.drag-scroll-arrow {' +
        'display: none;' +
        'position: absolute;' +
        'top: 50%;' +
        'transform: translateY(-50%);' +
        'z-index: 10;' +
        'width: 40px;' +
        'height: 40px;' +
        'border-radius: 50%;' +
        'background: rgba(255,255,255,0.95);' +
        'border: 1px solid rgba(0,0,0,0.1);' +
        'box-shadow: 0 2px 8px rgba(0,0,0,0.12);' +
        'cursor: pointer;' +
        'align-items: center;' +
        'justify-content: center;' +
        'transition: opacity 0.2s, box-shadow 0.2s;' +
        'padding: 0;' +
      '}' +
      '.drag-scroll-arrow:hover {' +
        'box-shadow: 0 4px 12px rgba(0,0,0,0.18);' +
      '}' +
      '.drag-scroll-arrow--prev { left: -4px; }' +
      '.drag-scroll-arrow--next { right: -4px; }' +
      '.drag-scroll-arrow svg {' +
        'width: 18px;' +
        'height: 18px;' +
        'stroke: #222;' +
        'fill: none;' +
        'stroke-width: 2;' +
        'stroke-linecap: round;' +
        'stroke-linejoin: round;' +
      '}' +
      '@media screen and (min-width: 768px) {' +
        '.drag-scroll-arrow.is-visible { display: flex; }' +
      '}' +
      '[data-drag-scroll] {' +
        'cursor: grab;' +
      '}' +
      '[data-drag-scroll].is-dragging {' +
        'cursor: grabbing;' +
        'user-select: none;' +
        'scroll-snap-type: none !important;' +
      '}' +
      '[data-drag-scroll].is-dragging * {' +
        'pointer-events: none;' +
      '}' +
      '';
    document.head.appendChild(style);
  }

  var svgPrev = '<svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"/></svg>';
  var svgNext = '<svg viewBox="0 0 24 24"><polyline points="9 6 15 12 9 18"/></svg>';

  function initDragScroll(el) {
    var isDown = false;
    var startX = 0;
    var scrollStart = 0;
    var hasDragged = false;

    // Create nav wrapper
    var navWrapper = document.createElement('div');
    navWrapper.className = 'drag-scroll-nav';
    el.parentNode.insertBefore(navWrapper, el);
    navWrapper.appendChild(el);

    // Move scrollbar into wrapper if next sibling
    var nextSibling = navWrapper.nextElementSibling;
    if (nextSibling && nextSibling.className.indexOf('scrollbar') !== -1) {
      navWrapper.appendChild(nextSibling);
    }

    // Create arrows
    var prevBtn = document.createElement('button');
    prevBtn.className = 'drag-scroll-arrow drag-scroll-arrow--prev';
    prevBtn.setAttribute('aria-label', 'Zurück');
    prevBtn.setAttribute('type', 'button');
    prevBtn.innerHTML = svgPrev;

    var nextBtn = document.createElement('button');
    nextBtn.className = 'drag-scroll-arrow drag-scroll-arrow--next';
    nextBtn.setAttribute('aria-label', 'Weiter');
    nextBtn.setAttribute('type', 'button');
    nextBtn.innerHTML = svgNext;

    navWrapper.appendChild(prevBtn);
    navWrapper.appendChild(nextBtn);

    // Update arrow visibility
    function updateArrows() {
      var maxScroll = el.scrollWidth - el.clientWidth;
      if (maxScroll <= ARROW_THRESHOLD) {
        prevBtn.classList.remove('is-visible');
        nextBtn.classList.remove('is-visible');
        return;
      }
      prevBtn.classList.toggle('is-visible', el.scrollLeft > ARROW_THRESHOLD);
      nextBtn.classList.toggle('is-visible', el.scrollLeft < maxScroll - ARROW_THRESHOLD);
    }

    el.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();
    setTimeout(updateArrows, 500);

    // Arrow clicks
    prevBtn.addEventListener('click', function () {
      el.scrollBy({ left: -el.clientWidth * 0.75, behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      el.scrollBy({ left: el.clientWidth * 0.75, behavior: 'smooth' });
    });

    // Prevent native browser drag on links/images
    el.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });

    // Mouse drag scrolling
    el.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      isDown = true;
      hasDragged = false;
      startX = e.pageX;
      scrollStart = el.scrollLeft;
      // Do NOT add is-dragging class yet — wait for actual movement
    });

    document.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      var dx = e.pageX - startX;

      // Only start dragging after threshold is exceeded
      if (!hasDragged) {
        if (Math.abs(dx) < DRAG_THRESHOLD) return;
        hasDragged = true;
        el.classList.add('is-dragging');
      }

      e.preventDefault();
      el.scrollLeft = scrollStart - dx;
    });

    document.addEventListener('mouseup', function () {
      if (!isDown) return;
      isDown = false;
      el.classList.remove('is-dragging');
    });

    // Prevent click only after actual drag
    el.addEventListener('click', function (e) {
      if (hasDragged) {
        e.preventDefault();
        e.stopPropagation();
        hasDragged = false;
      }
    }, true);
  }

  function init() {
    var elements = document.querySelectorAll('[data-drag-scroll]');
    elements.forEach(function (el) {
      if (!el.dataset.dragScrollInit) {
        initDragScroll(el);
        el.dataset.dragScrollInit = 'true';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var observer = new MutationObserver(function () {
    init();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
